<donut-button @click="openPromptFormModal" :show-upgrade-badge="showUpgradeBadge"><slot></slot></donut-button>